import { render, staticRenderFns } from "./PlayersCarousel.vue?vue&type=template&id=19c4cd4d&scoped=true"
import script from "./PlayersCarousel.vue?vue&type=script&lang=js"
export * from "./PlayersCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c4cd4d",
  null
  
)

export default component.exports